import { createSelector } from '@reduxjs/toolkit';
import { getWidgetUiState } from './getWidgetUiState';
import { getIOSMobile } from '../widget-ui/operators/getIOSMobile';
export const getIsIOSMobile = createSelector([getWidgetUiState], widgetUiState => getIOSMobile(widgetUiState));